{
  "commons": {
    "languages": {
      "en": "Engelska",
      "sv": "Svenska",
      "BG": "Bulgariska",
      "CS": "Tjeckiska",
      "DA": "Danska",
      "DE": "Tyska",
      "EL": "Grekiska",
      "en-GB": "Engelska (GB)",
      "en-US": "Engelska (US)",
      "ES": "Spanska",
      "ET": "Estniska",
      "FI": "Finska",
      "FR": "Franska",
      "HU": "Ungerska",
      "ID": "Indonesiska",
      "IT": "Italienska",
      "JA": "Japanska",
      "KO": "Koreanska",
      "LT": "Litauiska",
      "LV": "Lettiska",
      "NB": "Norska (Bokmål)",
      "NL": "Nederländska",
      "PL": "Polska",
      "PT": "Portugisiska",
      "RO": "Rumänska",
      "RU": "Ryska",
      "SK": "Slovakiska",
      "SL": "Slovenska",
      "SV": "Svenska",
      "TR": "Turkiska",
      "UK": "Ukrainska",
      "ZH": "Kinesiska",
      "AUTO_DETECT": "Automatisk identifiering"
    },
    "all": "Alla",
    "nothing": "Inget här för tillfället",
    "somethingWentWrong": "Något gick fel",
    "somethingWentWrongDesc": "Ett oväntat fel inträffade. Försök att ladda om sidan.",
    "noItems": "Inga objekt hittade",
    "pageNotFound": "Hoppsan! Sidan du letade efter hittades inte",
    "language": "Språk",
    "search": "Sök",
    "topNavSearch": {
      "placeholder": "Sök eller ställ en fråga",
      "relevantPassages": "Relevanta stycken"
    },
    "select": "Välj ett alternativ",
    "help": "Hjälp",
    "documentHistory": {
      "header": "Audit Trail",
      "events": {
        "version_created": "Ny version skapad",
        "version_published": "Version publicerad",
        "version_adopted": "Version beslutad",
        "version_archived": "Version arkiverad",
        "document_user_added": "{{firstName}} {{lastName}} tillagd som {{role}}",
        "document_user_removed": "{{firstName}} {{lastName}} borttagen som {{role}}",
        "workflow_step_user_added": "{{firstName}} {{lastName}} tillagd till steg \"{{workflowStepName}}\" med {{permission}} behörighet",
        "workflow_step_user_removed": "{{firstName}} {{lastName}} borttagen från steg \"{{workflowStepName}}\"",
        "workflow_transition": "Arbetsflöde flyttat från \"{{fromStepName}}\" till \"{{toStepName}}\"",
        "workflow_started": "Arbetsflöde startat",
        "workflow_completed": "Arbetsflöde slutfört"
      }
    },
    "buttons": {
      "accept": "Acceptera",
      "addUser": "Lägg till användare",
      "archiveProject": "Arkivera projekt",
      "cancel": "Avbryt",
      "close": "Stäng",
      "confirm": "Bekräfta",
      "confirmUpload": "Bekräfta uppladdning",
      "create": "Skapa ",
      "decline": "Neka",
      "delete": "Radera",
      "download": "Ladda ner",
      "downloadAs": "Ladda ner som",
      "downloadFile": "Ladda ner fil",
      "convertToWord": "Konvertera till Word (.docx)",
      "goToTheDashboardPage": "Gå till kontrollpanelen",
      "manage": "Hantera",
      "proceed": "Fortsätt",
      "back": "Tillbaka",
      "retry": "Försök igen",
      "reorder": "Ordna",
      "resetPass": "Återställ lösenord",
      "saving": "Sparar...",
      "saved": "Sparat",
      "save": "Spara",
      "seeAll": "Se alla",
      "sentInvitations": "Skicka inbjudningar",
      "submit": "Skicka",
      "copySelectionLink": "Kopiera länk till vald text",
      "done": "Klar",
      "showMore": "Visa mer",
      "selectAll": "Välj alla",
      "selectItem": "Välj {{name}}",
      "unselectAll": "Ta bort val",
      "selectAllFrom": "Välj alla från",
      "edit": "Redigera",
      "finish": "Avsluta",
      "validate": "Validera",
      "validating": "Validerar...",
      "expand": "Expandera",
      "collapse": "Kollapsa",
      "generateDiffSummary": "Generera AI-sammanfattning",
      "generatingDiffSummary": "Genererar...",
      "diffSummaryUpToDate": "Inga ändringar att sammanfatta"
    },
    "create": {
      "document": "Skapa nytt dokument"
    },
    "customSelect": {
      "enterOwner": "Ange ägare",
      "enterPublisher": "Ange utgivare",
      "selectDate": "Välj datum",
      "selectCategory": "Välj kategori",
      "selectDocument": "Välj dokument",
      "selectOption": "Välj alternativ",
      "selectTier": "Välj nivå"
    },
    "document": {
      "category": "Kategori",
      "categories": "Kategorier",
      "metadata": "Metadata",
      "owner": "Ägare",
      "publisher": "Utgivare",
      "referenceNumber": "Diarienummer",
      "reviewDates": "Granskningsdatum",
      "recurringReview": "Återkommande granskning",
      "reviewPeriods": {
        "every3months": "Var 3:e månad",
        "every6months": "Var 6:e månad",
        "yearly": "Årligen"
      },
      "reviewFrom": "Planerat startdatum",
      "reviewFromDescription": "Granskningen startar automatiskt",
      "reviewTo": "Planerat slutdatum",
      "reviewToDescription": "Granskningen visas som försenad",
      "reviewDatesMovedToWorkflow": "Planerade granskningsdatum har flyttat till",
      "goToWorkflowTab": "fliken Arbetsflöde.",
      "recurringPeriod": "Period",
      "status": "Status",
      "tag": "Tagg",
      "tags": "Taggar",
      "tier": "Nivå",
      "title": "Titel",
      "untitledDocument": "Namnlöst dokument",
      "youDontHaveAccess": {
        "title": "Du har inte rättigheter till att se detta dokument",
        "subtitle": "Kontakta en superadmin i din North House-plattform om du behöver tillgång"
      },
      "adopted": "Beslutad",
      "adoptedAt": "Beslutades",
      "publishedAt": "Publicerad",
      "emptyDocument": "Tomt dokument",
      "emptyDocumentDescription": "Dokumentet är för närvarande tomt. Använd knappen 'Öppna i' högst upp för att öppna det i Office for the web.",
      "emptyDocumentDescription2": "Använd menyn i det övre högra hörnet för att redigera dokumentmetadata och dokumentroller.",
      "fileSizeLimit": "Din fil måste vara mindre än 50MB.",
      "archivedVersionWarning": "Detta är en arkiverad version av dokumentet.",
      "goToLatestVersion": "Gå till den senaste versionen.",
      "archivedProject": "Detta dokument har arkiverats.",
      "links": "Länkade dokument"
    },
    "documentStatus": {
      "accepted": "Accepterat",
      "archived": "Arkiverad",
      "draft": "Utkast",
      "opened": "Öppnat",
      "published": "Publicerad"
    },
    "userStatus": {
      "active": "Aktiv",
      "deactivated": "Inaktiverad",
      "deleted": "Borttagen",
      "pending": "Väntar"
    },
    "download": {
      "documents": "Ladda ner dokument",
      "description": "Ladda ner alla publicerade dokument eller lägg till några av följande filter för att ladda ner en specifik grupp dokument.",
      "downloading": "Dokument nedladdade:",
      "error": "Ett oväntat fel inträffade vid nedladdning av dokumenten. Kontakta support@northhouse.se för att få hjälp med din förfrågan."
    },
    "filter": {
      "clear": "Rensa",
      "title": "Filter"
    },
    "loading": "Laddar...",
    "signOut": "Logga ut",
    "users": "Användare",
    "role": "Roll",
    "forms": {
      "selectAnOption": "Välj ett alternativ..."
    },
    "deleteConfirm": "Är du säker på att du vill fortsätta?",
    "tags": {
      "manageTagsDescription": "Skapa, ta bort och se vilka dokument som använder varje tagg.",
      "usedInXDocuments_one": "Används i {{count}} dokument",
      "usedInXDocuments_other": "Används i {{count}} dokument",
      "notUsed": "Används inte",
      "deleteSuccess": "Taggen har tagits bort",
      "deleteConfirmTitle": "Ta bort tagg",
      "deleteConfirmDescription": "Är du säker på att du vill ta bort denna tagg? Den används på {{count}} dokument.",
      "noTags": "Inga taggar",
      "noTagsDescription": "Skapa din första tagg för att komma igång.",
      "newTagPlaceholder": "Ange taggnamn...",
      "createSuccess": "Taggen skapades",
      "tagExists": "En tagg med detta namn finns redan"
    },
    "auth": {
      "forgotPassword": "Glömt lösenord",
      "loginTitle": "Logga in",
      "loginDescription": "Vänligen ange dina uppgifter för att logga in",
      "email": "E-post",
      "password": "Lösenord",
      "ssoDescription": "Tryck på knappen för att logga in med ditt jobbkonto",
      "ssoLogin": "Logga in med SSO",
      "emailPasswordLogin": "Logga in med e-post och lösenord",
      "twoFaTitle": "2FA-autentisering",
      "twoFaDescription": "Ange din kod från autentiseringsappen",
      "twoFaToken": "6-siffrig kod",
      "restoreAccount": "Återställ konto",
      "addSsoButton": "Anslut",
      "skipButton": "Hoppa över",
      "ssoRequiredToEdit": "Du behöver logga in med SSO för att redigera dokument",
      "cantEditSpeDraftFile": "Du behöver ha skrivrättigheter för att redigera detta utkast"
    },
    "errors": {
      "officeLocalhost": "Office är inte tillgängligt på localhost",
      "noDocument": "Dokumentet hittades inte"
    },
    "fileFormat": {
      "word": "Word (.docx)",
      "pdf": "PDF (.pdf)",
      "excel": "Excel (.xlsx)",
      "powerPoint": "PowerPoint (.pptx)"
    },
    "copyright": "North House AB. All Rights Reserved.",
    "translation": {
      "translationStarted": "Översättning påbörjad",
      "translationDownloaded": "Översättning nedladdad",
      "translationError": "Översättning misslyckades",
      "quotaExceededError": "Översättningskvoten har överskridits. Vänligen kontakta support.",
      "tooManyRequestsError": "För många översättningsförfrågningar. Vänligen försök igen senare.",
      "isTranslating": "Översätter...",
      "downloadTranslatedFile": "Ladda ner översatt fil",
      "selectLanguageDescription": "Välj ett språk att översätta till för att ladda ner en översatt version av detta dokument.",
      "selectTargetLanguage": "Språk att översätta till",
      "selectSourceLanguage": "Nuvarande språk",
      "selectLanguage": "Välj ett språk...",
      "translationStartedInfo": "Översättning har påbörjats. Du kan stänga detta fönster."
    },
    "workflows": {
      "search": "Sök arbetsflöden...",
      "workflow_one": "Arbetsflöde",
      "workflow_other": "Arbetsflöden",
      "ongoingAndUpcoming": "Pågående & kommande",
      "edit": "Redigera arbetsflöde",
      "stepUserResponses": {
        "approved": "{{firstName}} {{lastName}} godkände steget",
        "rejected": "{{firstName}} {{lastName}} avvisade steget",
        "pending": "{{firstName}} {{lastName}} har inte svarat än",
        "approvedSelf": "Du godkände steget",
        "rejectedSelf": "Du avvisade steget",
        "pendingSelf": "Du har inte svarat än"
      }
    },
    "managers": {
      "title": "Managers"
    },
    "classification": {
      "title": "Klassificering"
    },
    "unsavedChanges": {
      "title": "Osparade ändringar",
      "description": "Om du lämnar denna sida kommer dina osparade ändringar att försvinna.",
      "continueEditing": "Fortsätt redigera",
      "discardChanges": "Ignorera ändringar",
      "documentMetadata": {
        "title": "Ignorera metadataändringar?",
        "description": "Om du fortsätter kommer dina osparade metadataändringar att försvinna."
      },
      "metadataSheet": {
        "title": "Ignorera metadataändringar?",
        "description": "Om du stänger panelen kommer dina osparade metadataändringar att försvinna."
      },
      "documentTitle": {
        "title": "Ignorera titeländringar?",
        "description": "Om du fortsätter kommer dina osparade titeländringar att försvinna."
      },
      "workflow": {
        "title": "Ignorera arbetsflödesändringar?",
        "description": "Om du lämnar sidan kommer dina osparade arbetsflödesändringar att försvinna."
      }
    },
    "more": "Mer",
    "title": "Titel",
    "workflow": {
      "respond": {
        "comment": "Lämna kommentar",
        "reject": "Avvisa",
        "approve": "Godkänn",
        "leaveAnotherResponse": "Lämna ett till svar"
      },
      "stepTitleRequired": "Titel krävs",
      "stepDescription": "Stegbeskrivning",
      "review": "Granskning",
      "approvalNotAvailableFirstStep": "Godkännande (inte tillgängligt på första steget)",
      "type": "Typ",
      "responseDate": "Svarsdatum",
      "responseDateWarning": "Svarsdatumet för detta steg är tidigare än ett tidigare svarsdatum!",
      "description": "Beskrivning",
      "assignedUsers": "Tilldelade användare",
      "assigned": "Tilldelad:",
      "comment": "Kommentar",
      "approval": "Godkännande",
      "reviewRespond": "Granska & Svara",
      "noUsersAssigned": "Inga användare tilldelade",
      "addStep": "Lägg till steg",
      "steps": "Steg",
      "stepsDescription": "Definiera sekvensen av steg och tilldela användare till varje steg",
      "descriptionDescription": "Beskriv syftet med uppdateringen för att ge sammanhang för granskare, kommittéer och/eller godkännare",
      "saveChanges": "Spara ändringar",
      "manageWorkflows": "Hantera och spåra dokumentskapande och granskningsprocesser.",
      "ongoing": "Pågående",
      "upcoming": "Kommande",
      "mySteps": "Mina steg",
      "expandAll": "Expandera alla",
      "previousStep": "Föregående steg",
      "completedSteps": "slutförda steg.",
      "hideSteps": "Dölj steg",
      "showSteps": "Visa steg",
      "continue": "Fortsätt",
      "cancel": "Avbryt",
      "edit": "Redigera",
      "stepDueAt": "Förfaller: {{date}}",
      "delete": "Radera",
      "cannotDeleteOngoing": "Kan inte radera pågående eller avklarade steg",
      "cannotDeleteWithInstance": "Kan inte radera steg som har startats",
      "cannotDeleteFirstStep": "Kan inte radera det första steget i arbetsflödet",
      "read": "Läs",
      "completed": "Slutförd",
      "inProgress": "Pågående",
      "progress": "Framsteg",
      "notStarted": "Ej startat",
      "removeUser": "Ta bort användare",
      "approved": "Godkänd",
      "rejected": "Avvisad",
      "setAdoptionDate": "Sätt beslutsdatum",
      "changeAdoptionDate": "Ändra beslutsdatum",
      "setAdoptionDateDescription": "Välj datum när detta dokument antogs.",
      "noReviewSchedule": "Inget granskningsschema satt",
      "noReviewScheduleDescription": "Detta dokument har inget granskningsschema. Kontakta dokumentägaren för att sätta granskningsdatum.",
      "missingReviewDates": "Granskningsdatum saknas",
      "missingReviewDatesDescription": "Du har inte valt några granskningdatum. Dokumentet kommer att publiceras utan automatisk påminnelse om granskning.",
      "trackChangesEnabledWarning": "Track Changes är aktiverat i dokumentet",
      "trackChangesEnabledWarningDescription": "Detta dokument har Track Changes aktiverat, vilket betyder att ändringar och kommentarer kan synas för läsare. Öppna dokumentet i Word för att inaktivera Track Changes.",
      "unresolvedSuggestionsWarning": "Det finns olösta förslag i detta dokument",
      "unresolvedSuggestionsWarningDescription": "Acceptera eller avvisa förslagen i Word innan du publicerar så att läsarna bara ser slutversionen.",
      "commentsWarning": "Detta dokument innehåller kommentarer",
      "commentsWarningDescription": "Gå igenom kommentarerna i Word innan du publicerar så att feedback inte lämnas olöst.",
      "documentOpenInEditorError": "Dokumentet används",
      "documentOpenInEditorErrorDescription": "Stäng dokumentet i Office och försök igen. Om någon annan redigerar det kan du se vem i Office-titelfältet.",
      "publishDocument": "Publicera dokument",
      "nextReviewPeriod": "Nästa granskningsperiod",
      "nextReviewPeriodDescription": "Ange nästa granskningsperiod för att få en påminnelse när nästa granskning ska göras.",
      "startDate": "Startdatum för nästa översyn",
      "endDate": "Slutdatum för nästa översyn",
      "filterDocuments": "Filtrera dokument",
      "filterDocumentsDescription": "Begränsa vilka dokument som ska inkluderas i din export",
      "selectFields": "Välj fält att exportera",
      "selectFieldsDescription": "Välj vilka dokumentmetadatafält som ska inkluderas i din export",
      "exportAsCsv": "Exportera som CSV",
      "downloadReport": "Ladda ner rapport",
      "exportMetadata": "Exportera dokumentmetadata",
      "uploadFile": "Ladda upp fil",
      "uploadFileTitle": "Ladda upp fil",
      "replaceFileDescription": "Ersätt den aktuella filen för {{versionTitle}}",
      "fileToReplace": "Fil som ska ersättas",
      "replaceWarning": "Denna åtgärd kommer permanent att ersätta den befintliga filen och kan inte ångras.",
      "clickToSelectDifferent": "Klicka för att välja en annan fil",
      "clickOrDragToUpload": "Klicka eller dra en fil för att ladda upp",
      "cannotUploadFileWrongFormat": "Kan inte ladda upp \"{{fileName}}\". {{currentFileType}}-dokument kan endast ersättas med .{{allowedExtension}}-dokument.",
      "cannotUploadSfdtFile": "Kan inte ladda upp \"{{fileName}}\". SFDT-dokument kan endast ersättas med .docx-filer.",
      "invalidDocumentId": "Ogiltigt dokument-ID",
      "browseDescription": "Bläddra och hantera ditt dokumentbibliotek.",
      "editWorkflow": "Redigera",
      "createdFromTemplate": "Skapad från mall: {{name}}",
      "reading": "Läsning",
      "anchoring": "Förankring",
      "total": "Totalt",
      "opened": "Öppnat",
      "notOpened": "Ej öppnat",
      "readerStatusRead": "Läst",
      "accepted": "Accepterat",
      "reader": "Läsare",
      "status": "Status",
      "noReaders": "Inga läsare",
      "published": "Publicerad",
      "archived": "Arkiverat",
      "preview": "Förhandsvisning",
      "openInEditor": "Öppna i redigeraren",
      "readDocument": "Jag har läst detta dokument",
      "copyLinkToPublishedDocument": "Kopiera länk till publicerad version",
      "versionOrder": "Version {{order}}",
      "openInOffice": "Öppna i {{officeType}}",
      "openInOfficeForWeb": "Öppna i {{officeType}} for the web",
      "documentAlreadyOpenedByYou": "Dokumentet är för närvarande öppnat av dig",
      "documentAlreadyOpen": "Dokumentet är för närvarande öppnat av {{name}}",
      "versions": "Versioner",
      "addUser": "Lägg till användare...",
      "canEdit": "Kan redigera",
      "readOnly": "Endast läsning",
      "freeComment": "Kommenterade",
      "started": "Startad",
      "approvalDescription": "Du har blivit ombedd att godkänna detta dokument.",
      "writeDescription": "Du har tilldelats skrivbehörighet till detta dokument.",
      "readDescription": "Du har tilldelats läsbehörighet till detta dokument.",
      "waitingForApprovals": "Väntar på godkännande ({{approvedCount}}/{{totalCount}})",
      "you": "Du",
      "proceedWithRejectedResponses": "Fortsätt med avvisade svar?",
      "someParticipantsRejected": "Några deltagare har avvisat detta steg. Är du säker på att du vill fortsätta?",
      "proceedWithoutAllResponses": "Fortsätt utan alla svar?",
      "notAllResponded": "Inte alla deltagare har svarat på detta steg. Är du säker på att du vill fortsätta?",
      "nextStep": "Nästa steg",
      "startWorkflow": "Starta arbetsflöde",
      "created": "Skapad",
      "startedAt": "Startad",
      "failedToConfirmDocumentReading": "Misslyckades att bekräfta att du har läst dokumentet",
      "diffSummary": {
        "changesComparedTo": "Ändringar jämfört med",
        "upToDateTooltip": "En ny sammanfattning kan genereras när ändringar gjorts i dokumentet",
        "emptyState": {
          "description": "Genererar en koncis sammanfattning över skillnaderna mellan Version {{previousVersionNumber}} och Version {{currentVersionNumber}}"
        },
        "noChangesFound": "Inga ändringar hittades mellan versionerna. Gör ändringar i dokumentet och försök igen.",
        "tabTitle": "AI-sammanfattning"
      },
      "documentMarkedAsRead": "Dokumentet har markerats som läst",
      "documentConfirmed": "Dokumentet läst",
      "documentConfirmedDescription": "Du har markerat detta dokument som läst.",
      "documentReadyForReview": "Dokumentet redo för granskning",
      "pleaseConfirmDocumentRead": "Vänligen bekräfta att du har läst detta dokument.",
      "failedToAddReaders": "Misslyckades att lägga till läsare",
      "documentPublishedSuccessfully": "Dokumentet har publicerats",
      "failedToPublishDocument": "Misslyckades att publicera dokumentet",
      "allStepsMustHaveName": "Alla steg måste ha ett namn",
      "failedToUpdateWorkflow": "Misslyckades att uppdatera arbetsflödet",
      "workflowUpdatedSuccessfully": "Arbetsflödet har uppdaterats",
      "failedToUpdateWorkflowStep": "Misslyckades att uppdatera arbetsflödessteg"
    },
    "seasonal": {
      "halloween": "Glad Halloween!",
      "valentines": "Glad alla hjärtans dag! Unna dig lite choklad, det har du förtjänat!",
      "easter": "Glad Påsk! Hoppas påskharen hittar dig!"
    },
    "sections": {
      "title": "Sektioner",
      "viewSections": "Visa sektioner",
      "inDocuments": "I dokument",
      "unused": "Oanvända",
      "preview": "Förhandsvisning",
      "versionHistoryWithCount": "Versionshistorik ({{count}} version)",
      "versionHistoryWithCount_other": "Versionshistorik ({{count}} versioner)",
      "selectVersionToView": "Välj en version för att visa dess innehåll",
      "version": "Version",
      "createdAt": "Skapad",
      "createdBy": "Skapad av",
      "versionsCount": "{{count}} version",
      "versionsCount_other": "{{count}} versioner",
      "noSectionSelected": "Ingen sektion vald",
      "selectSectionDescription": "Välj en sektion från listan för att visa dess versioner",
      "noSectionsCreated": "Det finns inga sektioner skapade",
      "createSectionsHint": "Använd word add-in för att skapa sektioner",
      "usedInDocuments": "Används i dokument",
      "noDocuments": "Används inte i några dokument",
      "latest": "Senaste",
      "outdatedVersionsWarning": "Föråldrade versioner i användning",
      "usedInDocumentsCount": "Används i {{count}} dokument",
      "usedInDocumentsCount_other": "Används i {{count}} dokument"
    },
    "support": {
      "pageTitle": "Support",
      "contactSupport": "Kontakta Support",
      "contactDescription": "Behöver du hjälp? Har du en fråga eller hittat ett fel? Kontakta oss så återkommer vi så snart som möjligt.",
      "emailUs": "Maila oss på",
      "userGuide": "Användarguide",
      "userGuideDescription": "Lär dig hur du använder North House eller få svar på dina frågor i vår användarguide.",
      "viewGuide": "Visa Guide"
    },
    "addIn": {
      "createWarning": "Sektionen skapas synligt för alla användare i din plattform",
      "login": {
        "title": "Inloggning lyckades",
        "successMessage": "Du har loggat in på North House.",
        "instructions": "Du kan nu stänga detta fönster och återgå till Word.",
        "promptTitle": "North House Add-in",
        "promptMessage": "Logga in för att fortsätta",
        "buttonText": "Logga in",
        "reloadInstructions": "Efter inloggning, stäng inloggningsfönstret"
      },
      "buttons": {
        "creating": "Skapar...",
        "saveNewVersion": "Spara ny version",
        "saving": "Sparar...",
        "applyVersion": "Använd version",
        "createNewVersion": "Skapa ny version",
        "removeFromDocument": "Ta bort från dokument",
        "moreActions": "Fler åtgärder",
        "deleteVersion": "Ta bort version",
        "deleteSection": "Ta bort sektion",
        "previous": "Föregående",
        "next": "Nästa"
      },
      "forms": {
        "createFromSelection": "Skapa från markering",
        "newSectionNamePlaceholder": "Sektionens namn"
      },
      "version": {
        "versionLabel": "Version {{index}} av {{total}}",
        "versions": "{{count}}v",
        "versionPrefix": "v{{number}}"
      },
      "content": {
        "noContentAvailable": "Inget innehåll tillgängligt",
        "noSectionsYet": "Inga sektioner än.",
        "sectionsUsedInDocument": "Sektioner som används i detta dokument",
        "availableSections": "Tillgängliga sektioner",
        "noSectionsUsedInDocument": "Inga sektioner används i detta dokument",
        "noAvailableSections": "Inga tillgängliga sektioner"
      },
      "actions": {
        "createdByPrefix": "Skapad av"
      },
      "ui": {
        "usedIn": "Används i",
        "newerVersionAvailable": "Nyare version tillgänglig"
      },
      "messages": {
        "versionDeletedSuccess": "Versionen har tagits bort",
        "sectionDeletedSuccess": "Sektionen har tagits bort",
        "sectionCreatedSuccess": "Sektionen har skapats",
        "versionSavedSuccess": "Ny version har sparats",
        "deleteSectionTitle": "Ta bort sektion",
        "deleteSectionDescription": "Denna åtgärd kan inte ångras. Detta tar permanent bort alla versioner av sektionen {{sectionName}}.",
        "deleteSectionConfirm": "Ta bort sektion"
      },
      "errors": {
        "deleteSectionFailed": "Kunde inte ta bort sektion",
        "deleteVersionFailed": "Kunde inte ta bort version",
        "textSelectionCheckFailed": "Kunde inte kontrollera textmarkering. Försök igen.",
        "pleaseSelectTextFirst": "Markera text i dokumentet först",
        "logoutMayHaveFailed": "Utloggning kan ha misslyckats. Försök igen om det behövs.",
        "sectionInsertFailed": "Kunde inte infoga sektion",
        "sectionEditFailed": "Kunde inte redigera sektion",
        "sectionCreateNewVersionFailed": "Kunde inte skapa ny version",
        "sectionDiscardFailed": "Kunde inte ångra ändringar",
        "sectionSwitchVersionFailed": "Kunde inte byta version",
        "sectionSaveFailed": "Kunde inte spara ny version",
        "sectionRemoveFailed": "Kunde inte ta bort sektion",
        "sectionCreateFailed": "Kunde inte skapa sektion",
        "officeContextNotAvailable": "Något gick fel. Försök igen."
      }
    },
    "roles": {
      "superadmin": "Superadmin",
      "coordinator": "Koordinator",
      "contributor": "Redigerare",
      "reader": "Läsare"
    }
  },
  "legalEntities": {
    "legalEntity": "Legal entitet",
    "legalEntities": "Legal entiteter",
    "selectEntities": "Välj legala entiteter"
  },
  "workflowTemplates": {
    "title": "Arbetsflödesmallar",
    "navLabel": "Mallar",
    "deleteTemplate": "Radera mall",
    "templateName": "Mallnamn",
    "templateNamePlaceholder": "Ange mallnamn",
    "noTemplateSelected": "Välj en mall i sidopanelen för att redigera den",
    "noTemplates": "Inga mallar ännu. Skapa en för att komma igång.",
    "saveTemplate": "Spara mall",
    "saveSuccess": "Mallen har sparats",
    "saveError": "Kunde inte spara mall",
    "deleteSuccess": "Mallen har raderats",
    "deleteError": "Kunde inte radera mall",
    "templateNameRequired": "Mallnamn krävs",
    "newTemplate": "Ny mall",
    "tabs": {
      "editor": "Redigera",
      "applyToDocuments": "Tillämpa på dokument"
    },
    "documentsTable": {
      "title": "Tillämpa på dokument",
      "description": "Välj dokument att tillämpa denna arbetsflödesmall på. Endast dokument med ett utkast som inte har påbörjats visas.",
      "documentTitle": "Dokumenttitel",
      "currentTemplate": "Skapad från mall",
      "noDocuments": "Inga berättigade dokument hittades.",
      "selectedCount_one": "{{count}} dokument valt",
      "selectedCount_other": "{{count}} dokument valda",
      "searchPlaceholder": "Sök dokument...",
      "none": "Ingen",
      "saveTemplateFirst": "Spara mallen innan du tillämpar den på dokument."
    },
    "deleteConfirm": {
      "title": "Radera mall?",
      "description": "Är du säker på att du vill radera \"{{name}}\"? Denna åtgärd kan inte ångras.",
      "titleBulk": "Radera {{count}} mallar?",
      "descriptionBulk": "Är du säker på att du vill radera dessa {{count}} mallar? Denna åtgärd kan inte ångras."
    },
    "selectMode": "Välj",
    "deleteSelected": "Radera valda ({{count}})",
    "defaultBadge": "Standard",
    "cannotDeleteDefault": "Standardmallen kan inte raderas",
    "applyToDocuments": "Tillämpa på dokument ({{count}})",
    "applying": "Tillämpar...",
    "applySuccess": "Mallen har tillämpats på dokument",
    "applyError": "Kunde inte tillämpa mallen",
    "applyConfirm": {
      "title": "Ersätt befintliga mallar?",
      "description": "{{count}} av de valda dokumenten har redan en mall tillämpad. Att tillämpa denna mall ersätter deras nuvarande arbetsflöde.",
      "confirm": "Tillämpa ändå"
    },
    "applyOnWorkflow": {
      "selectPlaceholder": "Tillämpa en mall",
      "apply": "Tillämpa",
      "success": "Mallen har tillämpats",
      "error": "Kunde inte tillämpa mallen",
      "unsavedChangesTitle": "Kassera osparade ändringar?",
      "unsavedChangesDescription": "Du har osparade arbetsflödesändringar som kommer att gå förlorade när denna mall tillämpas.",
      "unsavedChangesConfirm": "Kassera & Tillämpa"
    },
    "applyDatesDialog": {
      "description": "Ange granskningsdatum och stegslutdatum för varje dokument innan mallen tillämpas.",
      "documentTitle": "Dokumenttitel",
      "apply": "Tillämpa mall",
      "confirmDates": "Bekräfta datum",
      "confirmDescription": "Granska datumen nedan och bekräfta för att tillämpa mallen.",
      "errorAfterPrevious": "Måste vara samma eller efter föregående datum",
      "errorNotInPast": "Får inte vara i det förflutna"
    }
  }
}
